export default __webpack_public_path__ + "static/media/Manrope-Bold.bf52bb7e.ttf";